import { useId } from 'react';
import { BOOK_SIZE_LABELS, BOOK_SIZES, type BookSize } from '../../shared/api';

const NONE = 'none';

interface SizePickerProps {
  label: string;
  selected: BookSize | null;
  onSelect: (size: BookSize | null) => void;
  disabled?: boolean;
}

/** Dropdown of rough book heights, with "Not set" for none. */
export function SizePicker({ label, selected, onSelect, disabled = false }: SizePickerProps) {
  const selectId = useId();
  return (
    <div className="select-field">
      <div className="select-field__row">
        <label htmlFor={selectId}>{label}</label>
        <select
          id={selectId}
          value={selected ?? NONE}
          disabled={disabled}
          onChange={(event) => {
            const { value } = event.target;
            onSelect(value === NONE ? null : (value as BookSize));
          }}
        >
          <option value={NONE}>Not set</option>
          {BOOK_SIZES.map((size) => (
            <option key={size} value={size}>
              {BOOK_SIZE_LABELS[size]}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
}
